"use client";
import React from "react";
import { H1, H4, P } from "@template/components";
import * as S from "./styles.ts";
import UniversalMarkdown from "@template/blocks/universal-markdown.tsx";

interface IDeliveryTermsSectionComponentProps {
  title?: string;
  subTitle?: string;
  links?: { label: string; href: string }[];
  showContent?: boolean;
  content?: string;
  sections?: {
    title: string;
    content: { text: string }[];
  }[];
}

const DeliveryTermsSectionComponent = ({
  title,
  subTitle,
  links,
  content: definition,
  sections,
  showContent = true,
}: IDeliveryTermsSectionComponentProps) => {
  // console.log(definition)
  return (
    <S.DeliveryTermsSectionWrapper>
      <S.DeliveryTermsSectionContainer>
        <H1>{title}</H1>
        <S.SubHeadingSection>
          <UniversalMarkdown>{subTitle}</UniversalMarkdown>
        </S.SubHeadingSection>
        <S.LinkItem>
          {links?.map((link, index) => (
            <a
              href={link.href}
              key={`link-${index}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {link.label}
            </a>
          ))}
        </S.LinkItem>
        {showContent && (
          <S.DeliveryTerms>
            <UniversalMarkdown>{definition}</UniversalMarkdown>
            {sections?.map((section, index) => (
              <React.Fragment key={index}>
                <H4 key={`section-${index}`}>{section.title}</H4>

                {section.content?.map((item, i) => (
                  <P key={`s-${index}-item-${i}`}>{item.text}</P>
                ))}
              </React.Fragment>
            ))}
          </S.DeliveryTerms>
        )}
      </S.DeliveryTermsSectionContainer>
    </S.DeliveryTermsSectionWrapper>
  );
};

export default DeliveryTermsSectionComponent;

export const options = [
  {
    description: "",
    displayName: "DeliveryTermsSectionComponent",
    methods: [],
    props: {
      definitions: {
        required: false,
        flowType: {
          name: "Array",
          elements: [
            {
              name: "signature",
              type: "object",
              raw: "{ text: string }",
              signature: {
                properties: [
                  {
                    key: "text",
                    value: {
                      name: "string",
                      required: true,
                    },
                  },
                ],
              },
            },
          ],
          raw: "{ text: string }[]",
        },
        description: "",
      },
      sections: {
        required: false,
        flowType: {
          name: "Array",
          elements: [
            {
              name: "signature",
              type: "object",
              raw: "{\n  title: string;\n  content: { text: string }[];\n}",
              signature: {
                properties: [
                  {
                    key: "title",
                    value: {
                      name: "string",
                      required: true,
                    },
                  },
                  {
                    key: "content",
                    value: {
                      name: "Array",
                      elements: [
                        {
                          name: "signature",
                          type: "object",
                          raw: "{ text: string }",
                          signature: {
                            properties: [
                              {
                                key: "text",
                                value: {
                                  name: "string",
                                  required: true,
                                },
                              },
                            ],
                          },
                        },
                      ],
                      raw: "{ text: string }[]",
                      required: true,
                    },
                  },
                ],
              },
            },
          ],
          raw: "{\n  title: string;\n  content: { text: string }[];\n}[]",
        },
        description: "",
      },
    },
  },
];
